import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './Balloon.css';

export enum BalloonColor {
    red = 'red'
}

export enum BalloonSize {
    n = 'n',
    s = 's'
}

interface BalloonProps {
    visible: boolean;
    cls?: string;
    size?: BalloonSize;
    theme?: BalloonColor;
}

export class Balloon extends React.PureComponent<BalloonProps> {
    render() {
        const { visible, cls, theme = BalloonColor.red, size = BalloonSize.n } = this.props;

        return (
            <span
                className={classNames(
                    cls,
                    Bem.cls('balloon', '', {
                        visible,
                        color: theme,
                        size
                    })
                )}
            />
        );
    }
}
